import React, {useState, ReactNode} from 'react';

interface AuthContextType {
    currentUser: boolean;
    setUser: (user: boolean) => void;
}

interface AuthUserProviderProps {
    user: boolean;
    children: ReactNode;
}

const AuthUserContext = React.createContext<AuthContextType | null>(null);

export default function AuthUserProvider({user, children}: AuthUserProviderProps) {

    const [currentUser, setUser] = useState(user);

    return (
        <AuthUserContext.Provider value={{currentUser, setUser}}>
            {children}
        </AuthUserContext.Provider>
    )
}

export function useAuth(): AuthContextType {
    return React.useContext(AuthUserContext)!
}